<template>
  <!-- Asked after a recording delete is confirmed, only when the recordings bagged peaks.
       Two explicit answers and no dismiss: the delete is already happening, so the only
       open question is the peaks, and a backdrop click shouldn't pick one silently. -->
  <div
    ref="modalRef"
    class="modal fade"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="removeBaggedPeaksModalTitle"
    aria-hidden="true"
    data-testid="remove-bagged-peaks-modal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 id="removeBaggedPeaksModalTitle" class="modal-title m-0">
            <strong>{{ $t('recorded_trails.remove_bagged_peaks.title') }}</strong>
          </h3>
        </div>
        <div class="modal-body">
          <p class="mb-0">
            {{ bulk ? $t('recorded_trails.remove_bagged_peaks.message_many') : $t('recorded_trails.remove_bagged_peaks.message_one') }}
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-testid="keep-bagged-peaks" @click="answer(false)">
            {{ $t('recorded_trails.remove_bagged_peaks.keep') }}
          </button>
          <button type="button" class="btn btn-danger" data-testid="remove-bagged-peaks" @click="answer(true)">
            {{ $t('recorded_trails.remove_bagged_peaks.remove') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Modal } from 'bootstrap'

export default {
  name: 'RemoveBaggedPeaksModal',
  data() {
    return {
      bulk: false,
      modalInstance: null as Modal | null,
      resolveAnswer: null as ((remove: boolean) => void) | null,
    }
  },
  mounted() {
    if (this.$refs.modalRef) {
      this.modalInstance = Modal.getOrCreateInstance(this.$refs.modalRef as HTMLElement)
    }
  },
  beforeUnmount() {
    // Never leave a caller awaiting an answer from a modal that's gone.
    this.answer(false)
    this.modalInstance?.hide()
  },
  methods: {
    // Resolves true for "Remove peaks", false for "Keep peaks".
    ask(bulk: boolean): Promise<boolean> {
      this.bulk = bulk
      return new Promise<boolean>((resolve) => {
        this.resolveAnswer = resolve
        this.modalInstance?.show()
      })
    },
    answer(remove: boolean) {
      const resolve = this.resolveAnswer
      this.resolveAnswer = null
      this.modalInstance?.hide()
      resolve?.(remove)
    },
  },
}
</script>
